/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MetaDataDto } from './MetaDataDto';
import {
    MetaDataDtoFromJSON,
    MetaDataDtoFromJSONTyped,
    MetaDataDtoToJSON,
    MetaDataDtoToJSONTyped,
} from './MetaDataDto';
import type { OrderDataDto } from './OrderDataDto';
import {
    OrderDataDtoFromJSON,
    OrderDataDtoFromJSONTyped,
    OrderDataDtoToJSON,
    OrderDataDtoToJSONTyped,
} from './OrderDataDto';

/**
 * 
 * @export
 * @interface FinancialDataDto
 */
export interface FinancialDataDto {
    /**
     * 
     * @type {string}
     * @memberof FinancialDataDto
     */
    categoryName: string | null;
    /**
     * 
     * @type {MetaDataDto}
     * @memberof FinancialDataDto
     */
    metadata: MetaDataDto;
    /**
     * 
     * @type {Array<FinancialDataDto>}
     * @memberof FinancialDataDto
     */
    subCategories?: Array<FinancialDataDto> | null;
    /**
     * 
     * @type {Array<OrderDataDto>}
     * @memberof FinancialDataDto
     */
    orders?: Array<OrderDataDto> | null;
}

/**
 * Check if a given object implements the FinancialDataDto interface.
 */
export function instanceOfFinancialDataDto(value: object): value is FinancialDataDto {
    if (!('categoryName' in value) || value['categoryName'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function FinancialDataDtoFromJSON(json: any): FinancialDataDto {
    return FinancialDataDtoFromJSONTyped(json, false);
}

export function FinancialDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryName': json['categoryName'],
        'metadata': MetaDataDtoFromJSON(json['metadata']),
        'subCategories': json['subCategories'] == null ? undefined : ((json['subCategories'] as Array<any>).map(FinancialDataDtoFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderDataDtoFromJSON)),
    };
}

export function FinancialDataDtoToJSON(json: any): FinancialDataDto {
    return FinancialDataDtoToJSONTyped(json, false);
}

export function FinancialDataDtoToJSONTyped(value?: FinancialDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryName': value['categoryName'],
        'metadata': MetaDataDtoToJSON(value['metadata']),
        'subCategories': value['subCategories'] == null ? undefined : ((value['subCategories'] as Array<any>).map(FinancialDataDtoToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderDataDtoToJSON)),
    };
}

